"use client";

import { DocxPlugin } from "@platejs/docx";
import { JuicePlugin } from "@platejs/juice";

export const DocxKit = [DocxPlugin, JuicePlugin];
